export default "__VITE_ASSET__B2krR03n__"